import { apiVersionHeader, apimSubscriptionKeyHeader } from "./consts";
import { apis } from "./apis";
import { fetchPageData } from "./pages";

// fetch static files
export const fetchStatic = async (url, headers = null, options = null) => {
  options = options ?? {
    method: "GET",
  };
  options.headers = headers ?? new Headers();

  try {
    const response = await fetch(url, options);
    if (response.status === 200) {
      return await response.json();
    }
    if (response.status === 204 || response.status === 404) {
      return response.status;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/**
 * A published data file (`path`: see ./paths.js): its JSON, 404 when it is not published, null on failure.
 * Read from the prerendered pages or from the JSON files, depending on `apis.dataApi.source`. No custom
 * headers on file requests: they stay "simple", so the browser sends no CORS preflight to the data site.
 */
export const fetchData = (path) =>
  apis.dataApi.source === "pages" ? fetchPageData(path) : fetchStatic(apis.dataApi.endpoint + path);

// Bundles fetched lately (path -> promise), most recent last: the hooks of a page ask for the same bundle at
// once, and going back to a page needs no request.
const cachedData = new Map();
const MAX_CACHED_DATA = 8;

/**
 * `fetchData` with one request per file for the hooks of a page. Failures are not cached, so the next call
 * tries again.
 */
export const fetchCachedData = (path) => {
  let pending = cachedData.get(path);
  if (pending) {
    cachedData.delete(path);
  } else {
    pending = fetchData(path).then((result) => {
      if (result === null) {
        cachedData.delete(path);
      }
      return result;
    });
  }
  cachedData.set(path, pending);
  while (cachedData.size > MAX_CACHED_DATA) {
    cachedData.delete(cachedData.keys().next().value);
  }
  return pending;
};

/**
 * A call to a backend API (`api`: see ./apis.js), null without a request when that API is not configured.
 */
export const fetchWithToken = async (
  resource,
  accessToken,
  headers = null,
  options = null,
  api = apis.watchlistsApi,
) => {
  if (!api) {
    return null;
  }
  const endpoint = api.endpoint + resource;

  headers = headers ?? new Headers();
  // const bearer = `Bearer ${accessToken}`;
  // headers.append("Authorization", bearer);
  headers.append("Accept", "application/json");

  if (api.apiVersion) {
    headers.append(apiVersionHeader, api.apiVersion);
  }
  if (api.subscriptionKey) {
    headers.append(apimSubscriptionKeyHeader, api.subscriptionKey);
  }

  options = options ?? {
    method: "GET",
  };
  options.headers = headers;

  try {
    const response = await fetch(endpoint, options);
    if (response.status === 200) {
      return await response.json();
    }
    if (response.status === 204 || response.status === 404) {
      return response.status;
    }

    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const fetchWithAuthConfig = async (
  resource,
  authConfig,
  headers = null,
  options = null,
  api = apis.watchlistsApi,
) => {
  // const token = await getAuthToken(authConfig);
  // if (!token) {
  //     return null;
  // }

  return await fetchWithToken(
    resource,
    /*token.accessToken*/ "no-token",
    headers,
    options,
    api,
  );
};
